import {TrackingPrice, TrackingTransactionPrice} from '../../../types';
export const getTrackingPriceDataFromProduct = (
  productPrice: TrackingPrice | TrackingTransactionPrice
) => {
  const price = calcCentsToEuro(productPrice.withoutTax);
  const tax = calcCentsToEuro(productPrice.withTax - productPrice.withoutTax);
  const saleAmount = getSaleAmount(productPrice);
  const strikeOutPriceNumber = calcCentsToEuro(productPrice.fullPrice);
  const strikeOutPrice = strikeOutPriceNumber.toFixed(2);

  return {
    price,
    tax,
    saleAmount,
    strikeOutPrice,
  };
};

export const calcCentsToEuro = (cents: number) => {
  return Number((cents / 100).toFixed(2));
};

export const getSaleAmount = (
  productPrice: TrackingPrice | TrackingTransactionPrice
) => {
  let reduction = 0;
  if (productPrice.saleReductionWithTax) {
    reduction += productPrice.saleReductionWithTax;
  }
  if (productPrice.campaignReductionWithTax) {
    reduction += productPrice.campaignReductionWithTax;
  }

  if (reduction === 0) {
    return reduction;
  } else {
    return calcCentsToEuro(reduction);
  }
};
